import {StudyContent} from '@cp/model';
import mapStudyContentToContent from './mapStudyContentToContent';

/**
 * Join an array of sections into a single string
 */
export default function joinStudyContentToContent(sections: StudyContent[]): string {
  return sections.map(mapStudyContentToContent).join('\n');
}
